import React, { useEffect, useState } from "react";
import ModalForm from "../../DynamicForm/ModalForm";
import Styles from "./TableComponent.module.css";


import { FaEdit } from "react-icons/fa";
import { MdDelete } from "react-icons/md";
import { useSelector } from "react-redux";


const TableComponent = ({ activeIndex, data, onActionClick, currentIndex, setCurrentIndex, setSentences, formData, setFormData, selectedSentence, setSelectedSentence, tableIndex, setTableIndex, steps, setSteps, }) => {
  // const [tableData, setTableData] = useState(data); // State to manage table data

  const multiStepProcessId = useSelector((state) => state.auth.multiStepProcessId)
  console.log(multiStepProcessId, 'multiss')
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [showAddNotepadBtn, setshowAddNotepadBtn] = useState(true);
  // const [selectedSentence, setSelectedSentence] = useState(null);
  const [editIndex, setEditIndex] = useState(null); // To track the index being edited
  console.log('selectesdsen', selectedSentence)
  console.log(steps)
  // Handle Add Notepad Button Click
  const handleAddNotepadClick = (tableIndex, index) => {
    // console.log(tableData[tableIndex].notepadData)
    console.log(currentIndex, 'currentIndex')
    setCurrentIndex(index)
    setTableIndex(tableIndex)
    setSelectedSentence(steps[tableIndex]?.boardData[index]?.sentence);
    setIsModalOpen(true);
  };
  console.log('shshsh', showAddNotepadBtn)


  console.log("tabledata", steps)

  // Handle Delete Action
  const handleDelete = (tableIndex, boardindex) => {
    // const updatedData = tableData.filter((_, i) => i !== index);
    const updatedData = steps[tableIndex]?.boardData
    const filteredBoardData = updatedData.filter((item, index) => index !== boardindex)
    console.log('filtered', filteredBoardData);
    // setSentences(filteredBoardData)

    setSteps((prevsteps) => {
      return prevsteps.map((item, index) => {
        if (index === tableIndex) {
          return { ...item, boardData: filteredBoardData }
        }
        else {
          return item
        }
      })
    })
    // setSteps(filteredData);
  };

  // Handle Edit Action
  const handleEdit = (tableindex, boardindex) => {
    setEditIndex(boardindex);
    setCurrentIndex(boardindex)
    setTableIndex(tableindex)
    setSelectedSentence(steps?.[tableindex]?.boardData[boardindex]?.sentence); // Set the selected data for editing
    let notepadData = steps?.[tableindex]?.boardData?.[boardindex]?.notepadData
    console.log(notepadData, 'dtaa')
    setFormData(notepadData)
    setIsModalOpen(true); // Open the modal for editing
  };

  // Handle Modal Form Submit
  const handleFormSubmit = (updatedSentence) => {
    if (editIndex !== null) {
      // Update the existing item
      const updatedData = [...steps];
      updatedData[editIndex] = updatedSentence;
      setSteps(updatedData);
      setEditIndex(null); // Reset the edit index
    } else {
      // Add new item
      setSteps([...steps, updatedSentence]);
    }
    setIsModalOpen(false);
  };

  return (
    <div className={Styles["table-container"]}>
      <table className={Styles["styled-table"]}>
        <thead>
          <tr>
            <th>No</th>
            <th className={Styles.Sentence}>Sentence</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {steps.map((item, tableindex) => (
            activeIndex === tableindex &&
            item?.boardData?.map((item, boardindex) => (
              <tr key={boardindex}>
                <td>{boardindex + 1}</td>
                <td>{item.sentence}</td>
                <td className={Styles.actionButtonContainer}>
                  {(!item?.boardDataAdded) && <button
                    onClick={() => handleAddNotepadClick(tableindex, boardindex)}
                    className={Styles["action-btn"]}
                  >
                    Add Notepad
                  </button>}
                  <div className={Styles.actionButtonContainer}>
                    {(item?.boardDataAdded) && <span

                      onClick={() => handleEdit(tableindex, boardindex)}
                      className={Styles["edit"]}
                    >
                      <FaEdit />
                    </span>}
                    {(item?.boardDataAdded) && <span
                      href="#"
                      onClick={() => handleDelete(tableindex, boardindex)}
                      className={Styles["delete"]}
                    >
                      <MdDelete />
                    </span>}
                  </div>
                </td>
              </tr>
            ))))}
        </tbody>
      </table>

      {/* Modal Form */}
      {isModalOpen && (
        <ModalForm
          isOpen={isModalOpen}
          onClose={() => setIsModalOpen(false)}
          steps={steps}
          // setSentences={setSentences}
          setshowAddNotepadBtn={setshowAddNotepadBtn}
          showAddNotepadBtn={showAddNotepadBtn}
          setSteps={setSteps}
          onSubmit={handleFormSubmit} // Handle form submit
          formData={formData}
          setFormData={setFormData}
          currentIndex={currentIndex}
          setCurrentIndex={setCurrentIndex}
          tableIndex={tableIndex}
          setTableIndex={setTableIndex}
        />
      )}
    </div>
  );
};

export default TableComponent;
